import { useEffect } from "react";
import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ContentProvider } from "@/lib/content";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import Reservation from "@/pages/Reservation";
import Quote from "@/pages/Quote";
import Location from "@/pages/Location";
import Vicenza from "@/pages/Vicenza";
import Careers from "@/pages/Careers";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Galleria from "@/pages/Galleria";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";

function PageTracker() {
  const loc = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    // Skip admin pages
    if (loc.pathname.startsWith("/admin")) return;
    api.post("/track", { page: loc.pathname, lang: i18n.language }).catch(() => {});
  }, [loc.pathname, i18n.language]);
  return null;
}

function Layout({ children }) {
  const { i18n } = useTranslation();
  useEffect(() => { document.documentElement.lang = i18n.language; }, [i18n.language]);
  return (
    <div className="min-h-screen flex flex-col bg-[#FAF9F6] text-[#2C2C2A]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <PageTracker />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/menu" element={<Layout><MenuPage /></Layout>} />
            <Route path="/prenota" element={<Layout><Reservation /></Layout>} />
            <Route path="/eventi" element={<Layout><Reservation initialTab="quote" /></Layout>} />
            <Route path="/dove-siamo" element={<Layout><Location /></Layout>} />
            <Route path="/da-vedere" element={<Layout><Vicenza /></Layout>} />
            <Route path="/lavora-con-noi" element={<Layout><Careers /></Layout>} />
            <Route path="/galleria" element={<Layout><Galleria /></Layout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
